import React from 'react';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import type { CccDashboardFilters } from './types';

const { RangePicker } = DatePicker;

type Props = {
  filters: CccDashboardFilters;
  onRequestsDateRangeChange: (range: [string | null, string | null]) => void;
};

const CccProposalRequestsFilters: React.FC<Props> = ({
  filters,
  onRequestsDateRangeChange,
}) => {
  const requestsRange: [Moment | null, Moment | null] =
    filters.requestsDateRange[0] && filters.requestsDateRange[1]
      ? [moment(filters.requestsDateRange[0]), moment(filters.requestsDateRange[1])]
      : [null, null];

  const handleRequestsRangeChange = (dates: [Moment | null, Moment | null] | null) => {
    if (dates?.[0] && dates[1]) {
      onRequestsDateRangeChange([
        dates[0].format('YYYY-MM-DD'),
        dates[1].format('YYYY-MM-DD'),
      ]);
    } else {
      onRequestsDateRangeChange([null, null]);
    }
  };

  return (
    <div className="filters-panel">
      <div className="filters-header">
        <div className="filters-header-left">
          <span className="filters-icon">🔍</span>
          <h3>Pedidos de proposta — intervalo</h3>
        </div>
      </div>
      <div className="filters-content">
        <div className="filters-main-row">
          <div className="time-filter-section">
            <label className="time-filter-label">Desde — Até (fim predefinido: hoje):</label>
            <RangePicker
              value={requestsRange}
              onChange={handleRequestsRangeChange}
              format="DD/MM/YYYY"
              size="middle"
              allowEmpty={[false, true]}
            />
            <div className="time-filter-buttons">
              <button
                type="button"
                className="time-filter-shortcut"
                onClick={() =>
                  onRequestsDateRangeChange([
                    moment().format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD'),
                  ])
                }
              >
                Hoje
              </button>
              <button
                type="button"
                className="time-filter-shortcut"
                onClick={() =>
                  onRequestsDateRangeChange([
                    moment().subtract(6, 'days').format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD'),
                  ])
                }
              >
                Últimos 7 dias
              </button>
              <button
                type="button"
                className="time-filter-shortcut"
                onClick={() =>
                  onRequestsDateRangeChange([
                    moment().subtract(29, 'days').format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD'),
                  ])
                }
              >
                Últimos 30 dias
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CccProposalRequestsFilters;
